import { trackChangeCountryOfCardIssuanceWhenBlocked } from 'actions';
import { Button } from 'components/ui/Button/Button';
import { Heading } from 'components/ui/Heading/Heading';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslations } from 'utils';
import { createMarkup } from 'utils/createMarkup/createMarkup';

import './Redirection.scss';

type RedirectionProps = {
  productType: string;
  onChangeCard: () => void;
  onChangeCountry: () => void;
};

const Redirection = ({
  productType,
  onChangeCard,
  onChangeCountry,
}: RedirectionProps) => {
  const dispatch = useDispatch();
  const handleClick = (evt: React.MouseEvent<HTMLButtonElement>): void => {
    evt.preventDefault();
    dispatch(trackChangeCountryOfCardIssuanceWhenBlocked({ productType }));
    onChangeCountry();
  };

  const i18n = useTranslations();
  const handleChangeCard = () => {
    onChangeCard();
  };

  return (
    <div className="Redirection" data-testid="redirection">
      <Heading as="h2" size="large" className="fontWeight-semiBold">
        {i18n.t('surcharge.confirm.title')}
      </Heading>
      <div className="Confirm-description">
        <p
          dangerouslySetInnerHTML={createMarkup(
            i18n.t('surcharge.confirm.blockedNonEEACards.description'),
          )}
        />
      </div>
      <footer>
        <Button
          tone="primary"
          size="full"
          onClick={handleClick}
          data-testid="changeSenderCountryBtn"
        >
          {i18n.t('surcharge.changePaymentMethodOrPaymentCountry.button')}
        </Button>
        <button
          onClick={handleChangeCard}
          className="Link"
          data-testid="changeCardBtn"
        >
          {i18n.t('surcharge.confirm.change')}
        </button>
      </footer>
    </div>
  );
};

export { Redirection };
